<template>
  <div id="time-picker" class="time-picker">
    <van-popup v-model="show" :close-on-click-overlay="false" position="bottom" :style="{height:'300px' }" >
      <van-datetime-picker v-model="currentDate" :formatter="formatter" type="date" :min-date="minDate" @change="changeClick" @cancel="cancelClick" @confirm="confirmClick"/>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    show: false,
    type: Number // 0 当天  1 3天 2 7天
  },
  data () {
    return {
      currentDate: new Date(),
      minDate: new Date(),
      values: ''
    }
  },
  methods: {
    formatter (type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      }
      return value
    },
    changeClick: function (picker) {
      // console.log(picker.getValues())
      // console.log(index)
      // console.log('确认===============' + this.values)
      this.values = picker.getValues()
    },
    confirmClick: function () {
      console.log(this.values)
      let value1 = this.values[0].substr(0, 4)
      let value2 = this.values[1].substr(0, 2)
      let value3 = this.values[2].substr(0, 2)
      this.$emit('timePicker', value1 + '-' + value2 + '-' + value3)
    },
    cancelClick: function () {
      // console.log('取消===============')
      this.$emit('timePicker', '')
    }
  },
  watch: {
    type: function (val) {
      this.type = val
      if (parseInt(this.type) === 1) {
        console.log()
        this.currentDate = new Date(new Date().getTime() + 4 * 86400000)
        this.minDate = new Date(new Date().getTime() + 4 * 86400000)
      }
      if (parseInt(this.type) === 2) {
        this.currentDate = new Date(new Date().getTime() + 8 * 86400000)
        this.minDate = new Date(new Date().getTime() + 8 * 86400000)
      }
      var date = this.currentDate
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1).toString()
      var day = date.getDate().toString()
      if (month.length <= 1) {
        month = '0' + month.toString()
      }
      if (day.length <= 1) {
        day = '0' + day.toString()
      }
      this.values = [year, month, day]
      console.log('当前时间===================' + this.type + ' ----' + this.values)
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/time-picker.vue